<template>
	<div class="wrap">
		<div class="wrap-title">
			<div class="wrap-title-line"></div>
			<div class="wrap-title-text">联系我们</div>
			<div class="wrap-title-line wrap-title-line-other"></div>
		</div>
		<div class="wrap-article">
			<div class="article-li">丁震医学教育始终秉持教育之心，立志帮助更多同学通过考试，想要更方便获取考试资讯请关注丁震医学教育各平台官方账号。</div>
		</div>
		<div class="wrap-img">
			<div class="img-li">
				<img src="https://test.dzyxedu.com/homeImage/contactImage1.png" alt="" />
				<div class="img-li-title">抖音扫码查看</div>
			</div>
			<div class="img-li">
				<img src="https://test.dzyxedu.com/homeImage/contactImage2.png" alt="" />
				<div class="img-li-title">丁震护理公众号</div>
			</div>
			<div class="img-li">
				<img src="https://test.dzyxedu.com/homeImage/contactImage3.png" alt="" />
				<div class="img-li-title">小红书</div>
			</div>
			<div class="img-li">
				<img src="https://test.dzyxedu.com/homeImage/contactImage4.png" alt="" />
				<div class="img-li-title">有赞小程序</div>
			</div>
			<div class="img-li">
				<img src="https://test.dzyxedu.com/homeImage/contactImage5.png" alt="" />
				<div class="img-li-title">答疑服务</div>
			</div>
			<div class="img-li">
				<img src="https://test.dzyxedu.com/homeImage/contactImage6.png" alt="" />
				<div class="img-li-title">快手</div>
			</div>
			<div class="img-li">
				<img src="https://test.dzyxedu.com/homeImage/contactImage7.png" alt="" />
				<div class="img-li-title">B站</div>
			</div>
		</div>
		<div class="contact-line"></div>
		<div class="contact-title">北京丁丁颐和科技有限公司</div>
		<div class="contact-info">
			<img src="https://img.js.design/assets/img/668f3d9f3ffae6f78ad2dc61.png#247915b9303ff77b13ba47687646b286" alt="" />
			公司电话：010-88453168
		</div>
		<div class="contact-info">
			<img src="https://img.js.design/assets/img/668f3d841af97b1f8e8a25df.png#369a771916f75f4e3c03b415296db87e" alt="" />
			公司地址：北京市石景山区石景山路3号玉泉大厦913
		</div>
		<div class="contact-line"></div>
		<div class="contact-title">广州丁丁舜思教育科技有限公司</div>
		<div class="contact-info">
			<img src="https://img.js.design/assets/img/668f3d9f3ffae6f78ad2dc61.png#247915b9303ff77b13ba47687646b286" alt="" />
			公司电话：020-88360980
		</div>
		<div class="contact-info">
			<img src="https://img.js.design/assets/img/668f3d841af97b1f8e8a25df.png#369a771916f75f4e3c03b415296db87e" alt="" />
			公司地址：广州市海珠区新港东路1166号101房自编1301单元
		</div>
		<div class="contact-line"></div>
		<div class="contact-title">北京丁丁颐和科技有限公司沈阳分公司</div>
		<div class="contact-info">
			<img src="https://img.js.design/assets/img/668f3d9f3ffae6f78ad2dc61.png#247915b9303ff77b13ba47687646b286" alt="" />
			公司电话：020-88360980
		</div>
		<div class="contact-info">
			<img src="https://img.js.design/assets/img/668f3d841af97b1f8e8a25df.png#369a771916f75f4e3c03b415296db87e" alt="" />
			公司地址：辽宁省沈阳市浑南区浑南三路6号
		</div>
	</div>
</template>
<script>
	export default {
		name: 'Contact',
		data() {
			return {};
		},
	};
</script>
<style scoped>
	@keyframes costumPulse {
		0% {
			-webkit-transform: scaleX(1);
			transform: scaleX(1);
		}
		50% {
			-webkit-transform: scale3d(1.05, 1.05, 1.05);
			transform: scale3d(1.05, 1.05, 1.05);
		}
		100% {
			-webkit-transform: scaleX(1);
			transform: scaleX(1);
		}
	}
	.wrap {
		max-width: 1520px;
		margin: auto;
		margin-top: 13px;
		margin-bottom: 60px;
		padding: 80px 96px 36px 184px;
		box-sizing: border-box;
		background-color: #fff;
		border-radius: 15px;
	}
	.wrap-title {
		margin: auto;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 37px;
	}
	.wrap-title-line {
		width: 296px;
		height: 5px;
		background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 158, 116, 1) 100%);
	}
	.wrap-title-line-other {
		background: linear-gradient(90deg, rgba(255, 158, 116, 1) 0%, rgba(255, 255, 255, 0) 100%);
	}
	.wrap-title-text {
		font-size: 32px;
		font-weight: 500;
		line-height: 46.34px;
		color: rgba(43, 46, 51, 1);
		margin: 0 53px;
	}
	.wrap-article {
		width: 100%;
		font-size: 18px;
		font-weight: 400;
		line-height: 46px;
		color: rgba(66, 66, 66, 1);
		padding-left: 30px;
		box-sizing: border-box;
	}
	.article-li {
		margin-bottom: 37px;
	}
	.wrap-img {
		width: 100%;
		display: flex;
		padding-left: 30px;
		box-sizing: border-box;
		margin-bottom: 25px;
	}
	.img-li {
		text-align: center;
		margin-right: 21px;
	}
	.img-li:hover {
		animation: costumPulse; /* referring directly to the animation's @keyframe declaration */
		animation-duration: 1s;
	}
	.img-li img {
		width: 109px;
		height: 109px;
		display: block;
	}
	.img-li-title {
		font-size: 14px;
		font-weight: 400;
		line-height: 20.27px;
		color: rgba(66, 66, 66, 1);
	}
	.contact-line {
		width: 100%;
		height: 0px;
		border: 1px solid rgba(166, 166, 166, 1);
		margin-bottom: 60px;
	}
	.contact-title {
		padding-left: 30px;
		box-sizing: border-box;
		font-size: 20px;
		font-weight: 400;
		line-height: 28.96px;
		color: rgba(56, 56, 56, 1);
		margin-bottom: 30px;
	}
	.contact-info {
		padding-left: 30px;
		box-sizing: border-box;
		display: flex;
		font-size: 16px;
		font-weight: 400;
		line-height: 23.17px;
		color: rgba(128, 128, 128, 1);
		align-items: center;
		margin-bottom: 28px;
	}
	.contact-info img {
		width: 32px;
		height: 32px;
		margin-right: 11px;
	}
</style>



// WEBPACK FOOTER //
// src/views/contact/contact.vue